import "./testimonial-slider-block.scss";